<template>
  <div>
    <v-dialog v-model="dialog" width="400" class="overwrite-dropzone-index">
      <template v-slot:activator="{ on, attrs }">
        <BtnBlue
          :btnTitle="$t('appButton.new_client')"
          v-bind="attrs"
          v-on="on"
          class="mb-6"
          @clicked="createNewClient"
        ></BtnBlue>
      </template>
      <NewClientForm @closeDialog="dialog = false"></NewClientForm>
    </v-dialog>
  </div>
</template>

<script>
import BtnBlue from "./BtnBlue.vue";
import NewClientForm from "./NewClientForm.vue";

export default {
  name: "newClientButton",

  components: {
    BtnBlue,
    NewClientForm,
  },

  data() {
    return {
      dialog: false,
      polling: null,
    };
  },

  computed: {
    isClientCreating() {
      return this.$store.getters.isClientCreating;
    },
  },

  watch: {
    isClientCreating(nVal) {
      if (nVal && this.polling == null) {
        this.polling = setInterval(
          () => this.$store.dispatch("fetch_clients"),
          30000
        );
      } else if (!nVal && this.polling !== null) {
        clearInterval(this.polling);
        this.polling = null;
      }
    },
  },

  methods: {
    createNewClient() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped></style>
